import { render, staticRenderFns } from "./effortTask.vue?vue&type=template&id=5fb82494&"
import script from "./effortTask.vue?vue&type=script&lang=js&"
export * from "./effortTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports